function mediacenter() {
  console.log('mediacenter');
  const compareCookie = "hypertheme:compare-products";
  const compareIsActiveCookie = "hypertheme:compare-is-active";
  
  // Loading overlay
  const loadingOverlay = document.getElementById('mediacenterLoadingOverlay');
  const showLoader = () => loadingOverlay?.classList.add('is-visible');
  const hideLoader = () => loadingOverlay?.classList.remove('is-visible');
  
  // Always set compare-is-active to true on mediacenter view
  if (FoxTheme.config.hasLocalStorage) {
    window.localStorage.setItem(compareIsActiveCookie, 'true');
    document.body.classList.add('is-product-comparing');
    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.publish('compare:toggle', { isActive: true });
    }
  }

  const swatches = document.querySelectorAll('.product-card .swatch-color');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  const buttons = document.querySelectorAll('.compare-bar__actions .btn--primary');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const products = FoxTheme.utils.getStorage(compareCookie);
      let downloadType = button.dataset.downloadType;
      let formData = {
        products,
        downloadType,
        locale: window.Shopify.locale,
        country: window.Shopify.country
      };
      
      // Disable button and show loading overlay
      button.disabled = true;
      showLoader();
      
      fetch(window.Shopify.routes.root + "apps/de-berkel/download", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then((blob) => {

          let zipFileName = "images";
          if (downloadType === "low") {
            zipFileName += "_1000";
          } else if (downloadType === "high") {
            zipFileName += "_3000";
          } else if (downloadType === "info") {
            zipFileName = "de_berkel_information";
          }

          // Create a temporary URL for the blob
          const url = window.URL.createObjectURL(blob);
          
          // Create a temporary anchor element and trigger download
          const a = document.createElement('a');
          a.href = url;
          a.download = zipFileName + '.zip';
          document.body.appendChild(a);
          a.click();
          
          // Cleanup
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          // Re-enable button and hide loading overlay
          button.disabled = false;
          hideLoader();
        });
      
    });
  });


}

document.addEventListener('DOMContentLoaded', mediacenter);


